import { useTranslation } from "react-i18next";
import { CATEGORIES } from "@/data/categories";

export default function Categories() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold">
            {t("categories.title")}
          </h2>
          <p className="mt-3 text-foreground-600">{t("categories.subtitle")}</p>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {CATEGORIES.map((c) => (
            <a
              key={c.key}
              href={c.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-lg bg-background-100 border border-background-200 overflow-hidden hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="relative w-full h-32 md:h-40 overflow-hidden bg-background-200">
                <img
                  src={c.image}
                  alt={`${t(c.key)} products`}
                  title={`${t(c.key)} on USFans Spreadsheet`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="flex items-center justify-between gap-2 px-3 md:px-4 py-3">
                <span className="text-sm md:text-base font-medium text-foreground-900 whitespace-nowrap">
                  {t(c.key)}
                </span>
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 shrink-0 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${c.icon} text-sm`}></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}